import Link from 'next/link';
import Image from 'next/image';
import {getUdemyLogos} from '@udemy-v2/react-brand-components';
import {useI18n} from '@udemy-v2/i18n';
import {LanguageSelectorButton, SelectorLocation} from '@udemy-v2/react-language-selector';

import styles from './footer.module.scss';

export function FooterInDemandCareesLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link className={styles['footer-section-content-item']} href="/career/data-scientist">
                {gettext('Data Scientist')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/career/full-stack-web-developer"
            >
                {gettext('Full Stack Web Developer')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/career/cloud-engineer">
                {gettext('Cloud Engineer')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/career/project-manager">
                {gettext('Project Manager')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/career/game-developer">
                {gettext('Game Developer')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/career-accelerators/">
                {gettext('See all Career Accelerators')}
            </Link>
        </div>
    );
}

export function FooterWebDevelopmentLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link className={styles['footer-section-content-item']} href="/topic/web-development/">
                {gettext('Web Development')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/javascript/">
                {gettext('JavaScript')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/react/">
                {gettext('React JS')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/angular/">
                {gettext('Angular')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/java/">
                {gettext('Java')}
            </Link>
        </div>
    );
}

export function FooterITCertificationLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link className={styles['footer-section-content-item']} href="/topic/amazon-aws/">
                {gettext('Amazon AWS')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/topic/aws-certified-cloud-practitioner/"
            >
                {gettext('AWS Certified Cloud Practitioner')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/microsoft-az-900/">
                {gettext('AZ-900: Microsoft Azure Fundamentals')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/topic/aws-certified-solutions-architect-associate/"
            >
                {gettext('AWS Certified Solutions Architect - Associate')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/kubernetes/">
                {gettext('Kubernetes')}
            </Link>
        </div>
    );
}

export function FooterLeadershipLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link className={styles['footer-section-content-item']} href="/topic/leadership/">
                {gettext('Leadership')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/topic/management-skills/"
            >
                {gettext('Management Skills')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/topic/project-management/"
            >
                {gettext('Project Management')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/topic/personal-productivity/"
            >
                {gettext('Personal Productivity')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/topic/emotional-intelligence/"
            >
                {gettext('Emotional Intelligence')}
            </Link>
        </div>
    );
}

export function FooterCertificationBySkillLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link
                className={styles['footer-section-content-item']}
                href="/browse/certification/cybersecurity-certifications/"
            >
                {gettext('Cybersecurity Certification')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/browse/certification/project-management-certifications/"
            >
                {gettext('Project Management Certification')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/browse/certification/cloud-certifications/"
            >
                {gettext('Cloud Certification')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/browse/certification/data-analytics-certifications/"
            >
                {gettext('Data Analytics Certification')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/browse/certification/hr-management-certifications/"
            >
                {gettext('HR Management Certification')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/browse/certification/">
                {gettext('See all Certifications')}
            </Link>
        </div>
    );
}

export function FooterDataScienceLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link className={styles['footer-section-content-item']} href="/topic/data-science/">
                {gettext('Data Science')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/python/">
                {gettext('Python')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/machine-learning/">
                {gettext('Machine Learning')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/chatgpt/">
                {gettext('ChatGPT')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/deep-learning/">
                {gettext('Deep Learning')}
            </Link>
        </div>
    );
}

export function FooterCommunicationLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link
                className={styles['footer-section-content-item']}
                href="/topic/communication-skills/"
            >
                {gettext('Communication Skills')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/topic/presentation-skills/"
            >
                {gettext('Presentation Skills')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/public-speaking/">
                {gettext('Public Speaking')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/writing/">
                {gettext('Writing')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/powerpoint/">
                {gettext('PowerPoint')}
            </Link>
        </div>
    );
}

export function FooterBusinessAnalyticsLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link className={styles['footer-section-content-item']} href="/topic/excel/">
                {gettext('Microsoft Excel')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/sql/">
                {gettext('SQL')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/topic/microsoft-power-bi/"
            >
                {gettext('Microsoft Power BI')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/topic/data-analysis/">
                {gettext('Data Analysis')}
            </Link>
            <Link
                className={styles['footer-section-content-item']}
                href="/topic/business-analysis/"
            >
                {gettext('Business Analysis')}
            </Link>
        </div>
    );
}

export function FooterAboutLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link
                className={styles['footer-section-content-item']}
                href="https://about.udemy.com/?locale=en-us"
            >
                {gettext('About us')}
            </Link>

            <Link
                className={styles['footer-section-content-item']}
                href="https://about.udemy.com/careers?locale=en-us"
            >
                {gettext('Careers')}
            </Link>

            <Link
                className={styles['footer-section-content-item']}
                href="https://about.udemy.com/company?locale=en-us#offices"
            >
                {gettext('Contact us')}
            </Link>

            <Link
                className={styles['footer-section-content-item']}
                href="https://blog.udemy.com/?ref=footer"
            >
                {gettext('Blog')}
            </Link>

            <Link
                className={styles['footer-section-content-item']}
                href="https://investors.udemy.com"
            >
                {gettext('Investors')}
            </Link>
        </div>
    );
}

export function FooterDiscoverLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link
                href="/mobile/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles['footer-section-content-item']}
            >
                {gettext('Get the app')}
            </Link>
            <Link
                href="/teaching/?ref=teach_footer"
                className={styles['footer-section-content-item']}
            >
                {gettext('Teach on Udemy')}
            </Link>
            <Link
                href="https://www.udemy.com/pricing/?ref=footer"
                className={styles['footer-section-content-item']}
            >
                {gettext('Plans and Pricing')}
            </Link>
            <Link href="/affiliate/" className={styles['footer-section-content-item']}>
                {gettext('Affiliate')}
            </Link>
            <Link href="/support/" className={styles['footer-section-content-item']}>
                {gettext('Help and Support')}
            </Link>
        </div>
    );
}

export function FooterUdemyBusinessLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link
                href="/udemy-business/?locale=en_US&amp;mx_pg=httpcachecontextsme-list&amp;path=%2F&amp;ref=footer"
                className={styles['footer-section-content-item']}
                target="_blank"
                rel="noopener noreferrer"
            >
                {gettext('Udemy Business')}
            </Link>
        </div>
    );
}

export function FooterLegalLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link
                className={styles['footer-section-content-item']}
                href="https://about.udemy.com/accessibility-statement?locale=en-us"
            >
                {gettext('Accessibility statement')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/terms/privacy/">
                {gettext('Privacy policy')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/sitemap/">
                {gettext('Sitemap')}
            </Link>
            <Link className={styles['footer-section-content-item']} href="/terms/terms-of-use/">
                {gettext('Terms')}
            </Link>
        </div>
    );
}

export function FooterTermsLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link href="/terms/terms-of-use/" className={styles['footer-section-content-item']}>
                {gettext('Terms')}
            </Link>
            <Link href="/terms/privacy" className={styles['footer-section-content-item']}>
                {gettext('Privacy Policy')}
            </Link>
            <Link href="/sitemap" className={styles['footer-section-content-item']}>
                {gettext('Sitemap')}
            </Link>
        </div>
    );
}

export function FooterCareersLinks() {
    const {gettext} = useI18n();

    return (
        <div className={styles['footer-section-content']}>
            <Link
                href="https://about.udemy.com/careers?locale=en-us"
                className={styles['footer-section-content-item']}
            >
                {gettext('Careers')}
            </Link>
            <Link
                href="https://blog.udemy.com/?ref=footer"
                className={styles['footer-section-content-item']}
            >
                {gettext('Blog')}
            </Link>
            <Link href="/support" className={styles['footer-section-content-item']}>
                {gettext('Help and Support')}
            </Link>
            <Link href="/affiliate" className={styles['footer-section-content-item']}>
                {gettext('Affiliate')}
            </Link>
        </div>
    );
}

export function LogoSection() {
    const {gettext} = useI18n();
    return (
        <div className={styles['logo-section']}>
            <div className={styles['logo-section-container']}>
                <Link href="/">
                    <Image
                        src={getUdemyLogos({colorScheme: 'dark'}).udemyLogoUrl}
                        alt="Udemy"
                        width={100}
                        height={100}
                    />
                </Link>
                <div className={styles['copyright']}>{gettext('© 2025 Udemy, Inc.')}</div>
            </div>
            <div></div>
            <div className={styles['language-selector-container-logo']}>
                <FooterLanguageSelector />
            </div>
        </div>
    );
}

export function LogoSectionMobile() {
    const {gettext} = useI18n();

    return (
        <div className={styles['logo-section-mobile']}>
            <div className={styles['logo-section-container-mobile']}>
                <FooterLanguageSelector />
                <Link href="/">
                    <Image
                        src={getUdemyLogos({colorScheme: 'dark'}).udemyLogoUrl}
                        alt="Udemy"
                        width={100}
                        height={100}
                    />
                </Link>
                <div className={styles['copyright']}>{gettext('© 2025 Udemy, Inc.')}</div>
            </div>
            <div></div>
        </div>
    );
}

export function FooterLanguageSelector() {
    return (
        <div className={styles['language-selector']}>
            <div className={styles['language-selector-icon-container']}>
                <LanguageSelectorButton
                    onLocaleChange={() => {
                        window.location.reload();
                    }}
                    selectorLocation={SelectorLocation.Footer}
                    withLabel={true}
                />
            </div>
            <div className={styles['filler']}></div>
        </div>
    );
}
